const Ccontinuous = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 32 32"
    >
      <g
        id="Raggruppa_574"
        data-name="Raggruppa 574"
        transform="translate(-1536 -435)"
      >
        <g
          id="Raggruppa_571"
          data-name="Raggruppa 571"
          transform="translate(945 41.842)"
        >
          <g
            id="Ellisse_19"
            data-name="Ellisse 19"
            transform="translate(594 396.158)"
            fill="none"
            stroke="#D2D2D2"
            stroke-width="2"
          >
            <circle cx="13" cy="13" r="13" stroke="none" />
            <circle cx="13" cy="13" r="12" fill="none" />
          </g>
          <text
            id="C"
            transform="translate(601 398.158)"
            fill="#D2D2D2"
            font-size="18"
            font-family="Roboto-Bold, Roboto"
            font-weight="700"
            letter-spacing="0.009em"
          >
            <tspan x="0" y="17">
              C
            </tspan>
          </text>
        </g>
        <rect
          id="Rettangolo_298"
          data-name="Rettangolo 298"
          width="32"
          height="32"
          transform="translate(1536 435)"
          fill="none"
        />
      </g>
    </svg>
  );
};

export default Ccontinuous;
